import { iGame } from '@/entities/game/game.types';
import { Game } from '@/entities/game/game';
import { ObjectLike } from '@/types/objectlike.types';
import { iFirestoreGameModel } from '../firestore.types';

const GAME_COLLECTION = 'game';
const SEARCH_LIMIT = 50;

export class FirestoreGameModel implements iFirestoreGameModel {
  private db: firebase.firestore.Firestore;

  constructor(db: firebase.firestore.Firestore) {
    this.db = db;
  }

  async findById(id: number): Promise<iGame> {
    const doc = await this.db.collection(GAME_COLLECTION)
      .doc(`${id}`)
      .get();

    if (!doc.exists) {
      throw new Error('game_not_found');
    }

    return new Game(doc.data() as ObjectLike);
  }

  async search(name: string): Promise<iGame[]> {
    const searchString = this.processSearchInput(name);

    console.log(searchString);

    const snapshot = await this.db.collection(GAME_COLLECTION)
      .where('keywords', 'array-contains', searchString)
      .orderBy('name', 'asc')
      .limit(SEARCH_LIMIT)
      .get();

    if (snapshot.empty) {
      return [];
    }
    const games: iGame[] = [];
    snapshot.forEach((game) => {
      games.push(new Game(game.data()));
    });

    return games;
  }

  private processSearchInput(name: string): string {
    return name.trim().toLocaleLowerCase();
  }
}
